// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + "login" + "." + "1f50b4c0" + ".chunk.css";
};